import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '@/assets/no-data/table-empty.png';
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  key: 0,
  class: "record-list"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
const _hoisted_4 = {
  class: "health-record-desc-page"
};
const _hoisted_5 = {
  class: "record-desc-table"
};
const _hoisted_6 = {
  class: "table-item flex"
};
const _hoisted_7 = {
  class: "table-left flex"
};
const _hoisted_8 = {
  class: "left-value flex-center"
};
const _hoisted_9 = {
  class: "table-right flex"
};
const _hoisted_10 = {
  class: "right-value flex-center border-none"
};
const _hoisted_11 = {
  class: "table-item flex border-none"
};
const _hoisted_12 = {
  class: "table-left flex"
};
const _hoisted_13 = {
  class: "left-value flex-center mobile"
};
const _hoisted_14 = {
  class: "table-right flex"
};
const _hoisted_15 = {
  class: "right-value flex-center border-none"
};
const _hoisted_16 = {
  class: "table-row-item flex"
};
const _hoisted_17 = {
  class: "row-item-value flex a-center"
};
const _hoisted_18 = {
  class: "table-row-item flex"
};
const _hoisted_19 = {
  class: "row-item-value flex a-center"
};
const _hoisted_20 = {
  class: "table-row-item flex"
};
const _hoisted_21 = {
  class: "row-item-value flex a-center"
};
const _hoisted_22 = {
  class: "table-row-item flex"
};
const _hoisted_23 = {
  class: "row-item-value flex a-center"
};
const _hoisted_24 = {
  class: "table-row-item flex"
};
const _hoisted_25 = {
  class: "row-item-value flex a-center"
};
const _hoisted_26 = {
  class: "table-row-item flex"
};
const _hoisted_27 = {
  class: "row-item-value flex a-center"
};
const _hoisted_28 = {
  class: "sum-name flex a-center"
};
const _hoisted_29 = ["src"];
import { reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { getHealthRecordApi, getHealthRecordListApi, getHealthRecordDescApi } from '@/service/modules/user';
import protoPagination from "@/components/proto-pagination.vue";
import useUserStore from '@/store/modules/user';
export default /*@__PURE__*/_defineComponent({
  __name: 'health-number-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    mobile: {
      type: String,
      required: true
    }
  },
  emits: ['closeDialog', 'restData'],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const userStore = useUserStore();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const list = ref([]);
    const recordList = ref([]);
    const recordTotal = ref(0);
    const page = reactive({
      current: 1,
      size: 10
    });
    const query = reactive({
      mobile: '',
      name: ''
    });
    const drawerDialogVisible = ref(false);
    const healthInfo = ref({});
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning('正在保存，请稍后~~');
      emit('closeDialog');
      list.value = [];
      recordList.value = [];
      page.current = 1;
      recordTotal.value = 0;
    }
    function handleFooterBtn(actionType) {
      closeDialog();
    }
    // 获取健康记录成员列表
    async function getHealthNumber() {
      try {
        let res = await getHealthRecordApi(props.mobile);
        list.value = res.data;
        console.log('list', list.value);
      } catch {}
    }
    // 获取成员健康记录
    function handleQueryHealthRecord(item) {
      page.current = 1;
      query.name = item.name;
      query.mobile = item.mobile;
      getHealthRecordList();
    }
    async function getHealthRecordList() {
      try {
        let res = await getHealthRecordListApi({
          ...page,
          ...query
        });
        recordList.value = res.data.records;
        recordTotal.value = res.data.total;
        if (recordList.value.length === 0) {
          ElMessage.warning('暂无健康记录');
        }
      } catch {}
    }
    // 健康记录分页
    function handleHecordCurrentChange(val) {
      page.page = val;
      getHealthRecordList();
    }
    // 健康记录详情
    async function handleQueryHealthRecordDesc(item) {
      try {
        let res = await getHealthRecordDescApi(item.id);
        healthInfo.value = res.data;
        drawerDialogVisible.value = true;
        // Bus.emit('handleCloseHealthNumberDialog')
        userStore.handleCloseHealthNumberDialog();
      } catch {}
    }
    function handleDrawerClose() {
      drawerDialogVisible.value = false;
      // Bus.emit('handleOpenHealthNumberDialog')
      userStore.handleOpenHealthNumberDialog();
      healthInfo.value = {};
    }
    watch(() => props.dialogVisible, newV => {
      if (newV === true) {
        getHealthNumber();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_drawer = _resolveComponent("el-drawer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "成员列表",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[1] || (_cache[1] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: list.value,
          "header-cell-style": {
            background: '#F7F9FB !important',
            color: '#111111',
            height: '42px',
            fontSize: '14px'
          }
        }, {
          empty: _withCtx(() => _cache[4] || (_cache[4] = [_createElementVNode("div", {
            class: "table-empty"
          }, [_createElementVNode("img", {
            class: "no-data",
            src: _imports_0,
            alt: ""
          }), _createElementVNode("div", {
            class: "empty-text"
          }, "暂无数据")], -1)])),
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "姓名",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "gender",
            label: "性别",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "familyMember",
            label: "关系",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              class: "m-r-10",
              onClick: $event => handleQueryHealthRecord(scope.row),
              type: "primary"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("查看")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), recordList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "record-title"
        }, "健康记录", -1)), _createVNode(_component_el_table, {
          data: recordList.value,
          "header-cell-style": {
            background: '#F7F9FB !important',
            color: '#111111',
            height: '42px',
            fontSize: '14px'
          }
        }, {
          empty: _withCtx(() => _cache[6] || (_cache[6] = [_createElementVNode("div", {
            class: "table-empty"
          }, [_createElementVNode("img", {
            class: "no-data",
            src: _imports_0,
            alt: ""
          }), _createElementVNode("div", {
            class: "empty-text"
          }, "暂无数据")], -1)])),
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "姓名",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "symptoms",
            label: "症状",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "创建时间",
            "show-overflow-tooltip": ""
          }), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              class: "m-r-10",
              onClick: $event => handleQueryHealthRecordDesc(scope.row),
              type: "primary"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("查看")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(protoPagination, {
          page: page,
          total: recordTotal.value,
          onCurrentChange: handleHecordCurrentChange
        }, null, 8, ["page", "total"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model-value"]), _createVNode(_component_el_drawer, {
        modelValue: drawerDialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => drawerDialogVisible.value = $event),
        title: "健康记录详情",
        size: "40%",
        "before-close": handleDrawerClose,
        direction: "rtl"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[10] || (_cache[10] = _createElementVNode("div", {
          class: "left-label flex-center"
        }, "姓名", -1)), _createElementVNode("div", _hoisted_8, _toDisplayString(healthInfo.value.name), 1)]), _createElementVNode("div", _hoisted_9, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "right-label flex-center"
        }, "性别", -1)), _createElementVNode("div", _hoisted_10, _toDisplayString(healthInfo.value.gender), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_cache[12] || (_cache[12] = _createElementVNode("div", {
          class: "left-label flex-center"
        }, "联系电话", -1)), _createElementVNode("div", _hoisted_13, _toDisplayString(healthInfo.value.mobile), 1)]), _createElementVNode("div", _hoisted_14, [_cache[13] || (_cache[13] = _createElementVNode("div", {
          class: "right-label flex-center"
        }, "服务消费", -1)), _createElementVNode("div", _hoisted_15, _toDisplayString(healthInfo.value.serviceConsumption), 1)])]), _createElementVNode("div", _hoisted_16, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "诊断机构", -1)), _createElementVNode("div", _hoisted_17, _toDisplayString(healthInfo.value.diagnosticInstitution), 1)]), _createElementVNode("div", _hoisted_18, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "症状", -1)), _createElementVNode("div", _hoisted_19, _toDisplayString(healthInfo.value.symptoms), 1)]), _createElementVNode("div", _hoisted_20, [_cache[16] || (_cache[16] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "诊断记录", -1)), _createElementVNode("div", _hoisted_21, _toDisplayString(healthInfo.value.diagnosticRecord), 1)]), _createElementVNode("div", _hoisted_22, [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "治疗方法", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString(healthInfo.value.treatmentMethod), 1)]), _createElementVNode("div", _hoisted_24, [_cache[18] || (_cache[18] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "诊后建议", -1)), _createElementVNode("div", _hoisted_25, _toDisplayString(healthInfo.value.postTreatmentAdvice), 1)]), _createElementVNode("div", _hoisted_26, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "row-item-label flex-center"
        }, "签字备注", -1)), _createElementVNode("div", _hoisted_27, _toDisplayString(healthInfo.value.signatureRemark), 1)]), _createElementVNode("div", _hoisted_28, [_cache[20] || (_cache[20] = _createElementVNode("div", {
          class: "sum-label"
        }, "机构负责人签字：", -1)), _createElementVNode("img", {
          class: "name-img",
          src: healthInfo.value.institutionHeadSignature,
          mode: "widthFix"
        }, null, 8, _hoisted_29)])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});